import JavaBlog from '../assets/Blog/JavaBlog.jpg';
import Loop from '../assets/Blog/Loop.jpg';
import API from '../assets/Blog/API.jpg';
import GitHub from '../assets/Blog/GitHub.jpg';
import JDK from '../assets/Blog/JDK.jpg';
import Quit from '../assets/Blog/Quit.jpg';

export const blogData = [
    {
        id: 1,
        title: 'My First Steps Into Java — And Why It Finally Started Making Sense',
        description: 'My first deep dive into Java—how I moved from confusion to clarity and finally understood the core concepts that every beginner struggles with.',
        date: 'Nov 15, 2025',
        image: JavaBlog,
        url: 'https://medium.com/@salonitomar5813/my-first-steps-into-java-and-why-it-finally-started-making-sense-3342f6125f20'
    },
    {
        id: 2,
        title: 'Loops in Java — The Beginner’s Guide You Wish You Had',
        description: 'An easy and clear beginner’s guide that explains all Java loops with simple logic, real examples, and practical use cases to help new learners understand how repetition works in programming.',
        date: 'Nov 22, 2025',
        image: Loop,
        url: 'https://medium.com/@salonitomar5813/loops-in-java-the-beginners-guide-you-wish-you-had-c77dec6fbeb9'
    },
    {
        id: 3,
        title: 'JDK vs JRE vs JVM — The Most Confusing Java Concepts Finally Made Easy',
        description: 'A quick and simple guide that breaks down the differences between JDK, JRE, and JVM. This explanation makes these core Java concepts easy to understand for beginners.',
        date: 'Nov 17, 2025',
        image: JDK,
        url: 'https://medium.com/@salonitomar5813/jdk-vs-jre-vs-jvm-the-most-confusing-java-concepts-finally-made-easy-d8819a64933d'
    },
    {
        id: 4,
        title: 'APIs Explained Through a Story — What They Are & How They Connect the World',
        description: 'A simple storytelling guide that explains what APIs are, how they work behind the scenes, and why they connect almost everything we use online.',
        date: 'Dec 8, 2025',
        image: API,
        url: 'https://medium.com/@salonitomar5813/apis-explained-through-a-story-what-they-are-how-they-connect-the-world-11275c0474a8'
    },
    {
        id: 5,
        title: 'GitHub: The Portfolio That Speaks Louder Than Your Resume',
        description: 'Showcasing my projects, skills, and learning journey—my GitHub is where code speaks, ideas shine, and potential turns into real work. More than a resume, it’s proof of what I can build and create.',
        date: 'Dec 10, 2025',
        image: GitHub,
        url: 'https://medium.com/@salonitomar5813/github-the-portfolio-that-speaks-louder-than-your-resume-906554103615'
    },
    {
        id: 6,
        title: 'Don’t Stop Now — You’re Not Done Yet',
        description: 'An easy and beginner-friendly reflection on personal growth, explaining how progress happens quietly through consistency, patience, and showing up.Uses simple ideas and real-life moments to highlight how unseen effort shapes long-term success.',
        date: 'Dec 14, 2025',
        image: Quit,
        url: 'https://medium.com/@salonitomar5813/dont-stop-now-you-re-not-done-yet-c33d20598079'
    }
]
